import { render, staticRenderFns } from "./FeaturedDorms.vue?vue&type=template&id=99067282&scoped=true&"
import script from "./FeaturedDorms.vue?vue&type=script&lang=js&"
export * from "./FeaturedDorms.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDorms.vue?vue&type=style&index=0&id=99067282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99067282",
  null
  
)

export default component.exports